(function () {
    'use strict';
    angular
        .module('ib-upgrading-bids-module')
        .controller('BidsController', BidsController);

    BidsController.$inject = ['object', '$scope', 'localStorageService', '$rootScope', '$route', 'MmBModalService', 'CommonsAncillariesService', 'CommonsUtilService', '$translate', 'CommonsModalService'];
    function BidsController (object, $scope, localStorageService, $rootScope, $route, MmBModalService, CommonsAncillariesService, CommonsUtilService, $translate, CommonsModalService) {
        const vm = this;
        vm.$onInit = activate();
        vm.toPmtview = toPmtview;
        vm.closeBidModal = closeBidModal;
        vm.flowFinished = flowFinished;
        vm.toConfirmation = toConfirmation;
        $scope.$on('toPmtView', toPmtview);
        $scope.$on('closeBidModal', closeBidModal);
        $scope.$on('flowFinished', flowFinished);
        const toConfirmationEvent = $rootScope.$on('toConfirmationBidEvent', toConfirmation);
        $scope.$on('$destroy', toConfirmationEvent);

        function activate () {
            const paymentRedirection = localStorageService.get('paymentRedirection') || null;
            $translate.onReady().then(() => { CommonsUtilService.setTitlePage('MMB_TITLE_PAGE_BID_OFFER'); });
            if (paymentRedirection) {
                localStorageService.remove('paymentRedirection');
                vm.model = {};
                toPmtview();
            } else {
                vm.model = {};
                vm.model.selection = object;
                vm.model.stepCtrl = 1;
            }
        }
        function toPmtview () {
            localStorageService.set('manualCloseVCModal', true);
            localStorageService.set('flowApp', 'MMBBID');
            vm.model.stepCtrl = 2;
        }
        function closeBidModal () {
            const upgBidPutMade = localStorageService.get('upgBidPutMade');
            const waitingListPurchased = localStorageService.get('waitingListPurchased');
            localStorageService.remove('upgAviosPutMade');
            localStorageService.remove('aviosprice');
            localStorageService.remove('numberFreeUpgrade');
            localStorageService.remove('paySucces');
            localStorageService.set('urlBidFlow', true);
            if (waitingListPurchased) {
                CommonsModalService.showWaitingModal('ib-modal-loading-plane', 'ib-modals ib-modals--transparent ib-modals--loading-page', true, null);
                CommonsAncillariesService.getAncillarieSummary().then((data) => {
                    localStorageService.set('breakdownInfo', data);
                    localStorageService.remove('waitingListPurchased');
                    $rootScope.$broadcast('upgBoxModuleWhenClosedModal');
                    CommonsModalService.finishWaiting();
                }, (error) => {
                    //reject(error);
                    CommonsModalService.finishWaiting();
                });
            }
            if (vm.model.stepCtrl < 2) {
                if (upgBidPutMade && !localStorageService.get('RechargeBookingInfo')) {
                    localStorageService.remove('upgBidPutMade');
                    localStorageService.remove('flowApp');
                    MmBModalService.closeAllCurrentModals();
                    $route.reload();

                } else if (localStorageService.get('RechargeBookingInfo')) {
                    localStorageService.remove('flowApp');
                    localStorageService.remove('redirectionPaymentCallback');
                    $rootScope.$broadcast('reloadImportOrder');
                }
                MmBModalService.closeAllCurrentModals();
            }
            if (vm.model.stepCtrl === 2) {
                const modalObject = {
                    title: 'MMB_UPGRADING_BIDS_EXIT_FLOW_TITLE',
                    subtitle: '',
                    body: 'MMB_UPGRADING_BIDS_EXIT_FLOW_INFO_TEXT',
                    accept: 'MMB_UPGRADING_BIDS_EXIT_FLOW_BUTTON_TEXT',
                    cancel: 'MMB_UPGRADING_BIDS_EXIT_FLOW_LINK_TEXT',
                    showCancelButton: true,
                    showCloseButton: true
                };
                CommonsModalService.showGenericComponentModal(modalObject, true).result.then(
                    () => {
                        flowFinished();
                        localStorageService.remove('upgBidPutMade');
                    },
                    () => {}
                );
            }
            if (vm.model.stepCtrl === 3) {
                localStorageService.remove('flowApp');
                localStorageService.remove('summaryBidTransformed');
                localStorageService.remove('sessionUpgradingBidsInfo');
                localStorageService.remove('actualStepFlow');
                $rootScope.$broadcast('reloadImportOrder');
                MmBModalService.closeAllCurrentModals();
            }
        }
        function flowFinished () {
            CommonsModalService.showWaitingModal('ib-modal-loading-plane', 'ib-modals ib-modals--transparent ib-modals--loading-page', true, null);
            const refresh = true, deferredRecall = undefined;
            //localStorageService.set('RechargeBookingInfo', true);
            localStorageService.remove('flowApp');
            localStorageService.remove('summaryBidTransformed');
            localStorageService.remove('sessionUpgradingBidsInfo');
            localStorageService.remove('redirectionPaymentCallback');
            localStorageService.remove('alreadyLoaded');
            CommonsAncillariesService.getAncillarieSummary(deferredRecall, refresh).then((data) => {
                localStorageService.set('breakdownInfo', data);
                $rootScope.$broadcast('reloadMMBDashboard');
                CommonsModalService.finishWaiting();
            }, (error) => {
                //reject(error);
                CommonsModalService.finishWaiting();
            });
            MmBModalService.closeAllCurrentModals();
        }

        function toConfirmation () {
            vm.model.stepCtrl = 3;
        }
    }
})();
